export const endpoints = {
  PAYMENT_RECEIPT: `cnaps-student/v1/orders/history`,
};

export const paymentReceiptTypes = {
  PAYMENT_RECEIPT_REQUEST: "student/PAYMENT_RECEIPT_REQUEST",
  PAYMENT_RECEIPT_SUCCESS: "student/PAYMENT_RECEIPT_SUCCESS",
  PAYMENT_RECEIPT_ERROR: "student/ PAYMENT_RECEIPT_ERROR",
};
